







































































































import {Component, Provide, Vue, Watch} from 'vue-property-decorator';
import Paginition from '@/components/Paginition.vue';
import Ship from '@/models/shiplist';
import FilterMenu from '@/components/FilterMenu.vue';

import {API} from '@/services/api/api';
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';

import {Filter} from '@/utils/Filter';

import {Utils} from '@/utils/Utils';
import {getShipList} from '@/services/api/common';
import ShipList from '@/models/shiplist';

@Component({
  methods: {
    ...mapActions(['showSuccessToast', 'showErrorToast', 'setupAppData', 'setShipList']),
  },
  // computed: {...mapGetters(['shipList'])},
  components: {
    Paginition,
    FilterMenu,
  },
})
export default class Ships extends Vue {
  //header filter(true false for showing filter menu)
  header = [
    {
      value: 'name',
      name: 'Ship Name',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'fileName',
      name: 'File Name',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'comments',
      name: 'Comments',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'isActive',
      name: 'Status',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
    {
      value: 'created',
      name: 'Created',
      headerType: 'date',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'edit',
      name: 'Edit',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
  ];
  shipList: []; //api response
  filteredShipList: Ship[] = [];
  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point
  curentSort = ''; //current sort on which header

  //Store Variable
  showSuccessToast: any;
  showErrorToast: any;
  setShipList: any;

  //Modal & Loader Variable
  isScreenLoading = true;
  modalVisible = false;
  loadingBtnStatus = false;
  modalConfimationMsg: any = null;
  modalTitle: any = null;

  shipId: any = null;
  deleteStatus: any = null;

  asdcOrder = true;

  setupAppData: any;

  //sorting list
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredShipList);
    this.asdcOrder = sorted;
  }

  mounted() {
    this.fetchShipList();
  }

  //fetch list from api
  async fetchShipList() {
    const response = await getShipList();
    if (response?.data.length > 0) {
      this.shipList = response.data;
      this.filteredShipList = this.shipList;
      this.setShipList();
      this.isScreenLoading = false;
    }
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }
  // format date to human readable string
  formatDate(originalDate: string) {
    let formattedDate = Utils.formatDate(originalDate);
    return formattedDate;
  }

  //filter data based upon string parameters
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.shipList);

    this.filteredShipList = filteredData;
    this.resetPagination();
  }

  //filter data based upon date parameters
  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.shipList);
    this.filteredShipList = filteredData;
    this.resetPagination();
  }

  //reset all filters and show current list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredShipList = this.shipList;
      this.resetPagination();
    }
  }

  //show delete confirmation  modal
  displayDeleteModal(recordId: number) {
    this.shipId = recordId;
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure want to delete ?';
    this.deleteStatus = true;
  }

  //show activate/deactivate  confirmation  modal
  displayStatusModal(recordId: number, recordEnableStatus: boolean) {
    this.shipId = recordId;
    let msg;
    if (recordEnableStatus) {
      msg = 'Deactivate';
    } else {
      msg = 'Activate';
    }
    this.modalVisible = true;
    this.modalTitle = `${msg} Confirmation`;
    msg = msg.toLowerCase();
    this.modalConfimationMsg = `Are you sure want to ${msg} ?`;
    this.deleteStatus = false;
  }

  //call delete or activate/deactivate method based upon confirmation
  async deleteOrChangeStatus() {
    try {
      const response = await this.changeStatus(this.shipId);

      if (response.data) {
        await this.fetchShipList();
        this.showSuccessToast({msg: response.message});
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //change status of ship
  async changeStatus(shipId) {
    const ship: any = this.shipList.find((ship: any) => ship.shipId === shipId);
    const shipStatus = !ship.isActive;
    return await API.activateOrDeactivateShip(this.shipId, shipStatus);
  }

  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  // navigate to edit-ship screen
  public editShip(shipId: number) {
    this.$router.push({path: '/edit-ship/' + shipId});
  }

  //
}
